<template>
  <div class="beginners-tips">
    <!--banner-->
    <div class="banner">
      <img src="../assets/beginners_tips_banner.jpg" alt="">
      <!-- <div class="banner-title">
        <img src="../assets/beginners_tips_title.png" alt="">
      </div> -->
    </div>
    <!--指南轮播-->
    <BeginnersTipsSwiper/>
    <!--规划-->
    <BeginnersTipsPlan/>
    <!--产品说明-->
<!--    <BeginnersExplain/>-->
    <!-- footer -->
    <base-footer />
  </div>
</template>

<script>
import BaseFooter from '@/components/BaseFooter'
// import BeginnersExplain from './beginners_tips/BeginnersExplain'
import BeginnersTipsPlan from './beginners_tips/BeginnersTipsPlan'
import BeginnersTipsSwiper from './beginners_tips/BeginnersTipsSwiper'
export default {
  name: 'PageBeginnersTips',

  components: {
    BaseFooter,
    // BeginnersExplain,
    BeginnersTipsPlan,
    BeginnersTipsSwiper
  },

  data () {
    return {}
  }
}
</script>

<style lang="less" scoped>
.beginners-tips{
  .banner{
    width: 100%;
    position: relative;
    img{
      width: 100%;
      display: block;
    }
    .banner-title{
      position: absolute;
      width: 220px;
      height: 220px;
      top: 50%;
      left: 50%;
      margin-left: -110px;
      margin-top: -110px;
    }
  }
}
</style>
